module.exports = __webpack_public_path__ + "img/Security-assessment.eebd6482.png";